import React from 'react';
import { TextBox } from '@apply/components';

interface ReferralSearchTextBoxProps {
    value: string;
    onChange: (value: string) => void;
}

export const ReferralSearchTextBox: React.FC<ReferralSearchTextBoxProps> = ({ value, onChange }) => {
    return (
        <>
            <TextBox
                value={value}
                onChange={(value) => onChange(value)}
                placeholder='Search to Filter Referrals...'
                required={false}
            />
        </>
    );
};
